import { useConfirm } from 'primevue/useconfirm'
import { useI18n } from '@/i18n'

export function useConfirmDelete() {
  const confirm = useConfirm()
  const { t } = useI18n()

  /**
   * Shows a styled confirmation dialog. Returns a Promise<boolean>.
   * @param {string} message  — The body text of the confirm dialog
   * @param {string} [header] — Optional dialog title (defaults to i18n key)
   */
  const confirmDelete = (message, header) => {
    return new Promise((resolve) => {
      confirm.require({
        message,
        header:       header ?? t('common.confirmDeleteTitle'),
        icon:         'pi pi-exclamation-triangle',
        rejectLabel:  t('common.cancel'),
        acceptLabel:  t('common.delete'),
        rejectClass:  'p-button-secondary p-button-outlined',
        acceptClass:  'p-button-danger',
        accept:  () => resolve(true),
        reject:  () => resolve(false),
        onHide: () => resolve(false),
      })
    })
  }

  return { confirmDelete }
}
